exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-uploader__drop-area[data-v-6394e986]{display:flex;flex-direction:column;justify-content:space-around;align-items:center;margin:1.5rem 0 2rem}.profile-uploader__drop-area--hover[data-v-6394e986]{opacity:.5}.profile-uploader__drop-text[data-v-6394e986]{margin-bottom:.5rem!important;font-size:1.125rem;text-align:center}", ""]);

// exports
